const ERROR = 'error';
const WARN = 'warn';
const INFO = 'info';
const DEBUG = 'debug';
const TRACE = 'trace';

export const logTypes = [ERROR, WARN, INFO, DEBUG, TRACE];
export const allLogTypes = {
	ERROR,
	WARN,
	INFO,
	DEBUG,
	TRACE
};
